import PropTypes from 'prop-types';

const TemplateListPropType = {
  updateDialog: PropTypes.func.isRequired,
};

export default TemplateListPropType;
